import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./components/Layout/MainLayout";
import Dashboard from "./pages/Dashboard";
import Notifications from "./pages/Notifications";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Tasks from "./pages/Tasks";
import Pipelines from "./pages/Pipelines";
import Documents from "./pages/Documents";
import Invoices from "./pages/Invoices";
// Inbox removed per user request
import TeamChat from "./pages/TeamChat";
import Team from "./pages/Team";
import Reports from "./pages/Reports";
import ProductionReport from "./pages/ProductionReport";
import Settings from "./pages/Settings";
import TagManagement from "./pages/TagManagement";
import CustomFields from "./pages/CustomFields";
import AccountSettings from "./pages/AccountSettings";
import CompanySettings from "./pages/CompanySettings";
import CustomerSettings from "./pages/CustomerSettings";
import NotificationSettings from "./pages/NotificationSettings";
import Login from "./pages/Login";
import { Toaster } from "./components/ui/toaster";
import { CompanyProvider } from "./contexts/CompanyContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// App content with routing
const AppContent = () => {
  const { isAuthenticated } = useAuth();
  
  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/*" element={
        <ProtectedRoute>
          <MainLayout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/pipelines" element={<Pipelines />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/invoices" element={<Invoices />} />
              {/* Inbox removed per user request */}
              <Route path="/team-chat" element={<TeamChat />} />
              <Route path="/team" element={<Team />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/reports/production" element={<ProductionReport />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/settings/tags" element={<TagManagement />} />
              <Route path="/settings/custom-fields" element={<CustomFields />} />
              <Route path="/settings/account" element={<AccountSettings />} />
              <Route path="/settings/company" element={<CompanySettings />} />
              <Route path="/settings/customers" element={<CustomerSettings />} />
              <Route path="/settings/notifications" element={<NotificationSettings />} />
            </Routes>
          </MainLayout>
        </ProtectedRoute>
      } />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CompanyProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
          <Toaster />
        </CompanyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
